export default __webpack_public_path__ + "static/media/9t.f98d815e.jpg";